import React from "react";
import AddEmployee from "./AddEmployee";
export const AddEmployeeIndex: React.FC = () => {

    return (
        <AddEmployee/>
    )
} 